export default "__VITE_ASSET__190ff572__"